<template>
  <div class="w-full px-4 my-3">
    <div class="text-sm">
      <div
        class="flex cursor-pointer"
        :class="{
          'bg-primary-400 hover:bg-primary-300 text-white dark:bg-dark-400 dark:hover:bg-dark-300 rounded-top dark:text-dark-text':
            isSummaryExpanded,
          'rounded-all hover:bg-gray-100 dark:hover:bg-dark-500': !isSummaryExpanded
        }"
        @click="click"
      >
        <span v-if="isSummaryExpanded" class="material-icons pr-2 h-full my-auto w-12" style="padding-left: 14px">
          arrow_drop_up
        </span>
        <span v-else class="material-icons pr-2 h-full my-auto w-12" style="padding-left: 14px"> arrow_drop_down </span>
        <div class="w-full">
          <slot name="labels" />
        </div>
      </div>
      <div
        v-if="loading"
        class="border shadow-md flex justify-center items-center border-primary-50 dark:border-dark-400"
        style="height: 120px; border-bottom-left-radius: 0.5rem; border-bottom-right-radius: 0.5rem"
      >
        <LoadingPanel />
      </div>
      <div
        v-show="!loading"
        :class="{
          'rounded-bottom border shadow-md border-primary-50 dark:border-dark-400': isSummaryExpanded
        }"
      >
        <Transition name="slide-fade">
          <div v-show="isSummaryExpanded">
            <div class="w-full">
              <slot name="body" />
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import LoadingPanel from '@/presentation/components/Loading/LoadingPanel.vue'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  name: 'NestedElement',
  components: { LoadingPanel },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    isSummaryExpanded: {
      type: Boolean,
      required: true
    }
  },
  setup(props, ctx) {
    const { isLightMode } = useConfigStatePresenter()

    const click = () => {
      ctx.emit('clickSummary')
    }

    return {
      isLightMode,
      click
    }
  }
})
</script>

<style lang="postcss" scoped>
.slide-fade-enter-active {
  transition: all 0.4s ease-out;
  overflow: hidden;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-in;
  overflow: hidden;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-16px);
  opacity: 0;
}

.left-slide-fade-enter-active {
  transition: all 0.2s ease-in;
  overflow: hidden;
  transition-delay: var(--delay, 0ms);
}

.left-slide-fade-enter-from,
.left-slide-fade-leave-to {
  transform: translateX(-32px);
  opacity: 0;
}

.rounded-all {
  border-radius: 0.5rem;
}

.rounded-top {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.rounded-bottom {
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
</style>
